import { format } from 'date-fns';
import {
  SET_PROOFREAD_LANGUAGES,
  SET_PROOFREADS,
  SET_HISTORY_PROOFREADS,
  SET_CURRENT_TASK
} from '../mutations.js';
import apiRequest from '../../js/helpers/apiRequest.js';
import UTCDateToLocalDate from '../../js/helpers/UTCDateToLocalDate.js';

export default {
  state: {
    languages: {
      in: [],
      out: []
    },
    proofreads: [],
    history: [],
    currentTaskId: null
  },

  mutations: {
    [SET_PROOFREAD_LANGUAGES]: (state, language) => {
      state.languages.in = language.in;
      state.languages.out = language.out;
    },

    [SET_PROOFREADS]: (state, proofreads) => {
      state.proofreads = proofreads;
    },

    [SET_HISTORY_PROOFREADS]: (state, history) => {
      state.history = history;
    },

    [SET_CURRENT_TASK]: (state, id) => {
      state.currentTaskId = id;
    }
  },

  actions: {
    async getTranslatedLanguages({ commit }) {
      const res = await apiRequest('translatedLanguages', 'GET', null);

      if (res.success) {
        commit(SET_PROOFREAD_LANGUAGES, {
          in: res.success.in.map(({ id, name, code, active }) => ({
            id,
            name,
            code,
            active: !!active
          })),
          out: res.success.out.map(({ id, name, code, active }) => ({
            id,
            name,
            code,
            active: !!active
          }))
        });
      }
    },

    async getProofreads({ commit }) {
      try {
        const res = await apiRequest('teacher/proofreads', 'GET', null, true);

        if (res.success) {
          commit(
            SET_PROOFREADS,
            res.success
              .map(
                ({
                  id,
                  status,
                  message,
                  text_in,
                  text_out,
                  type,
                  lang_id_in,
                  lang_id_out,
                  start,
                  end,
                  created_at
                }) => ({
                  id,
                  status,
                  message,
                  textIn: text_in,
                  textOut: text_out,
                  type,
                  langIdIn: lang_id_in,
                  langIdOut: lang_id_out,
                  createdAt: format(new Date(UTCDateToLocalDate(created_at)), 'dd.MM.yyyy hh:mm'),
                  start: start && format(new Date(UTCDateToLocalDate(start)), 'dd.MM.yyyy hh:mm'),
                  end: end && format(new Date(UTCDateToLocalDate(end)), 'dd.MM.yyyy hh:mm')
                })
              )
              .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          );
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getProofreadsHistory({ commit }) {
      try {
        const res = await apiRequest('teacher/proofreads/history', 'GET', null, true);

        if (res.success) {
          commit(
            SET_HISTORY_PROOFREADS,
            res.success
              .map(
                ({
                  id,
                  status,
                  message,
                  text_in,
                  text_out,
                  type,
                  lang_id_in,
                  lang_id_out,
                  start,
                  end,
                  created_at
                }) => ({
                  id,
                  status,
                  statusInBoolean: status === 'DONE' ? true : false,
                  message,
                  textIn: text_in,
                  textOut: text_out,
                  type,
                  langIdIn: lang_id_in,
                  langIdOut: lang_id_out,
                  createdAt: format(new Date(UTCDateToLocalDate(created_at)), 'dd.MM.yyyy hh:mm'),
                  start: start && format(new Date(UTCDateToLocalDate(start)), 'dd.MM.yyyy hh:mm'),
                  end: end && format(new Date(UTCDateToLocalDate(end)), 'dd.MM.yyyy hh:mm')
                })
              )
              .sort((a, b) =>
                a.statusInBoolean === b.statusInBoolean ? 0 : a.statusInBoolean ? 1 : -1
              )
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
